import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import LinePaperclipIcon from 'LuxKit/Icons/line/LinePaperclipIcon'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'
import type { TripDocument } from 'tripPlanner/types/documents'
import { formatFileSize } from 'tripPlanner/utils/documents'

const Root = styled(Group)`
  border-radius: ${(props) => props.theme.borderRadius.S};
  padding: ${rem(12)};
  background-color: ${(props) =>
    props.theme.palette.messaging.success.lightBackground};

  &.state-error {
    background-color: ${(props) =>
      props.theme.palette.messaging.critical.lightBackground};
  }
`

const MainSection = styled.div`
  flex: 1;
`

interface Props {
  document: TripDocument
}

function FileUploadSuccess({ document }: Props) {
  return (
    <Root direction="horizontal" gap={12} verticalAlign="center" fullWidth>
      <LinePaperclipIcon size="XS" colour="neutral-two" />
      <MainSection>
        <Caption variant="medium" lineClamp={1}>
          {document.filename}
        </Caption>
        {!!document.size && (
          <Caption variant="medium" colour="neutral-three">
            {formatFileSize(document.size)}
          </Caption>
        )}
      </MainSection>
    </Root>
  )
}

export default FileUploadSuccess
